import Field from 'common/uiV3/Field';
import { Select, type SelectBaseOption } from 'common/uiV3/Select';
import React from 'react';

type Props = {
  options: SelectBaseOption[];
  value: string[];
  filterLabel: string;
  onChange: (selectedIds: string[] | null) => void;
  saveError?: boolean;
};

const SourceFilter = ({ options, value, filterLabel, onChange, saveError }: Props) => (
  <Field>
    <Field.Label>{filterLabel}</Field.Label>
    <Field.Content>
      <Select
        allowClear={true}
        onValueChange={(value) => onChange(value ?? null)}
        options={options}
        placeholder="Everything"
        value={value}
        isMultiSelect
        maxVisible={10}
      />
      {saveError && <Field.Error>Something went wrong, please contact support.</Field.Error>}
    </Field.Content>
  </Field>
);

export default SourceFilter;
